import { out } from "@/lib/output/out";
import type { SessionDetail } from "@/lib/session/session-detail";

export function printPlaybookSteps(
  steps: NonNullable<SessionDetail["playbook"]>["steps"],
): void {
  if (steps.length === 0) {
    return;
  }
  out.line();
  for (const step of steps) {
    const done = step.todos.filter(
      (todo) => todo.status === "completed",
    ).length;
    const marker =
      done === step.todos.length && step.todos.length > 0 ? "✓" : "·";
    out.line(
      `  ${marker} ${out.cell(step.title)} ${out.paint(`${done}/${step.todos.length}`, "dim")}`,
    );
  }
}
